import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { fetchCollectionsThunk } from 'slices/collections/thunk';
import { AppDispatch, RootState } from 'store';
import PostCollection from './PostCollection';
import AccountCollection from './AccountCollection';
import Loader from 'Components/Common/Loader';
import { DEFAULT_CREATOR_COLLECTION_ID, DEFAULT_POST_COLLECTION_ID } from 'constants/global';

const Collection = () => {
    const { collectionId } = useParams();

    const collectionData = useSelector((state: RootState) => state.collections.list);
    const defaultCollections = collectionData?.default ?? null;
    const collections = collectionData?.items ?? [];
    const [loading, setLoading] = useState(false);

    const dispatch: AppDispatch = useDispatch();

    const collectionType = useMemo(() => {
        if (!collectionId) return null;
        if (collectionId === DEFAULT_CREATOR_COLLECTION_ID) return 'account';
        if (collectionId === DEFAULT_POST_COLLECTION_ID) return 'post';
        const collection = collections.find((c) => c.uuid === collectionId);
        return collection?.type;
    }, [collectionId, collections])

    useEffect(() => {
        setLoading(true);
        dispatch(fetchCollectionsThunk({})).finally(() => setLoading(false));
    }, [])

    if (loading) return <Loader/>

    return (
        <div>
            {
                collectionType === 'account' && (
                    <AccountCollection />
                )
            }
            {
                collectionType === 'post' && (
                    <PostCollection />
                )
            }
        </div>
    )
}

export default Collection